import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OmpPickerService } from '..';

// Upload dropzone for a section image. Drives the shared gallery via OmpPickerService and emits
// the chosen image URL as [value]. Empty value -> upload prompt; set value -> preview + replace/remove.
@Component({
  selector: 'omp-image-field',
  templateUrl: './omp-image-field.component.html',
  styleUrls: ['./omp-controls.scss'],
})
export class OmpImageFieldComponent {
  @Input() value: string;
  @Input() hint = '';
  @Output() valueChange = new EventEmitter<string>();

  constructor(private picker: OmpPickerService) {}

  browse() {
    this.picker.pickImage().then((image) => {
      if (image) {
        this.valueChange.emit(this.picker.fileUrl(image));
      }
    });
  }

  clear(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.valueChange.emit('');
  }
}
